export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7602.a6881327.jpg";